import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const Login = lazy(() => import('../pages/login/page'));
const Automotive = lazy(() => import('../pages/solutions/automotive/page'));
const Terms = lazy(() => import('../pages/terms/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const PrivacyEn = lazy(() => import('../pages/privacy/en/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/dashboard',
    element: <Dashboard />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/solutions/automotive',
    element: <Automotive />
  },
  {
    path: '/terms',
    element: <Terms />
  },
  {
    path: '/privacy',
    element: <Privacy />
  },
  {
    path: '/privacy/en',
    element: <PrivacyEn />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
